import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './smart-field.html';

const smartFieldConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('smartfield', {
		title: 'Smart Field',
		template,
		icon: 'fa fa-outdent',
		tableView: (/** @type {any} */ data) => (data ? data.name : ''),
		children:   false,
		selectable: true,
		settings: {
			autofocus: false,
			clearOnHide: true,
			conditional: {
				eq: '',
				show: undefined,
				when: undefined,
			},
			defaultValue: null,
			disabled: false,
			displayInputPopup: false,
			displaySuggestBtn: false,
			event: {
				onChange: undefined,
			},
			hidden: false,
			hideLabel: false,
			input: true,
			inputMask: '',
			inputType: 'text',
			kdata: {
				mf_order: undefined,
				sm_qrcode: false,
				submit: true,
			},
			key: 'smartField',
			label: 'Smart Field',
			persistent: true,
			placeholder: '',
			prefix: '',
			protected: false,
			spellcheck: true,
			suffix: '',
			tableView: true,
			validate: {
				custom: '',
				maxLength: null,
				minLength: null,
				pattern: '',
				card: '0-1',
				unique: false,
			},
		},
		views: [
			{
				name: 'Display',
				template: 'kform/components/smartfield/display.html',
			},
			{
				name: 'Data',
				template: 'kform/components/smartfield/data.html',
			},
			{
				name: 'Validation',
				template: 'kform/components/smartfield/validate.html',
			},
			{
				name: 'API',
				template: 'kform/components/common/api.html',
			},
			{
				name: 'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name: 'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name: 'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller:    /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.changeValue = () => {
				if (typeof $scope.component.event?.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.tmpDefaultValue = angular.copy($scope.component.defaultValue);

			$scope.$watch('tmpDefaultValue', () => {
				const values = $scope.tmpDefaultValue.map((/** @type {any} */ v) => ({
					kid:  v.kid,
					name: v.name,
				}));
				$scope.component.defaultValue = values[0];
			}, true);
		}
	});
};

export default angular.module('app').config(smartFieldConfig);
